/**
 * ServerErrorPage — Página 500 para errores internos del servidor / app
 * Exporta: ServerErrorPage (named + default)
 * Invoca: ErrorPage (@/pages/error/ErrorPage)
 * NO debe contener lógica de negocio.
 * Se usa como fallback del ErrorBoundary cuando hay un crash inesperado.
 */

import { ServerCrash } from "lucide-react";
import { ErrorPage } from "./ErrorPage";

interface ServerErrorPageProps {
  /** Detalle técnico del error (se muestra en un bloque de código) */
  errorDetail?: string;
}

export const ServerErrorPage = ({ errorDetail }: ServerErrorPageProps) => (
  <ErrorPage
    code="500"
    title="Error inesperado"
    description="Algo salió mal en la aplicación. El equipo ha sido notificado. Intenta recargar la página o vuelve más tarde."
    icon={<ServerCrash className="w-12 h-12 text-red-500" />}
    accentColor="text-red-600 dark:text-red-400"
    errorDetail={errorDetail}
    showReload
  />
);

export default ServerErrorPage;
